import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./languages.css";

const CreativeBadgeCloud = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: "ease-out-cubic",
    });
  }, []);

  const techNames = [
    "Android",
    "Angular",
    "Ansible",
    "AWS",
    "Azure",
    "Bash",
    "C",
    "C++",
    "Clojure",
    "Dart-Flutter",
    "Django",
    "Docker",
    "Elixir",
    "Figma",
    "Firebase",
    "Git",
    "Go",
    "GraphQL",
    "HTML",
    "iOS",
    "Java-Spring",
    "JavaScript",
    "Jenkins",
    "jQuery",
    "Jupyter",
    "Kafka",
    "Kotlin",
    "Kubernetes",
    "Laravel",
    "MongoDB",
    "MySQL",
    "Node.js",
    "OpenAI",
    "Python",
    "PyTorch",
    "PHP",
    "PostgreSQL",
    "React",
    "Ruby",
    "Rust",
    "Salesforce",
    "Scala",
    "Selenium",
    "Shopify",
    "Svelte",
    "Swift",
    "Tableau",
    "TensorFlow",
    "Terraform",
    "TypeScript",
    "Unity",
    "Vue.js",
    "WordPress",
  ];

  // Fix special icon names

  const getIconName = (name) => {
    return name
      .toLowerCase()
      .replace(/\.js/g, "js")
      .replace(/[^a-z0-9+]/g, "");
  };

  return (
    <div className="cr-main-wrapper">
      {/* Header */}
      <div className="cr-header-container" data-aos="fade-down">
        <h1 className="cr-heading-primary">Filter for technologies</h1>
        <p className="cr-description-text">
          Explore supported tools and technologies below.
        </p>
      </div>

      {/* Badge Cloud */}
      <div className="cr-badge-cloud-container" data-aos="zoom-in">
        {techNames.map((tech, idx) => {
          const delay = (idx % 10) * 50;

          return (
            <div
              key={idx}
              className="cr-individual-badge"
              data-aos="fade-up"
              data-aos-delay={delay}
            >
              <img
                src={`/it-images/${getIconName(tech)}.svg`}
                alt={tech}
                className="cr-badge-icon"
                loading="lazy"
                onError={(e) => {
                  e.target.src = "/it-images/react.svg"; // fallback
                }}
              />
              <span className="cr-badge-label">{tech}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CreativeBadgeCloud;
